export default __webpack_public_path__ + "static/media/team-16px.2704a7c9.svg";